{
  "notifications": {
    "tripContainsTrain": {
      "text": "Please <strong>check in for your train connection separately on Deutsche Bahn site</strong> using your <strong>Finnair booking reference</strong>.",
      "linkText": "Check in with Deutsche Bahn"
    }
  }
}
